define('utils/toast', [
    'utils/dom'
], function (dom) {
    'use strict';

    var timer = null
    var el = null
    var body = document.body
    var supportTransition
    var mask = null

    var appendDom = function (text) {
        if (!el) {
            el = document.createElement('div')
            el.className += 'toast'
            mask = document.createElement('div')
            mask.className += 'com-mask fixed full'
            mask.style.display = 'block'
            mask.style.backgroundColor = 'transparent'

            supportTransition = el.style.transition !== void 0;

            if (supportTransition) {
                el.addEventListener('transitionend', function (e) {
                    var target = e.target
                    if (parseFloat(target.style.opacity) === 0) {
                        removeElem(body, target, mask)
                    }
                })

                el.addEventListener('transitioncancel', function (e) {
                    var target = e.target
                    removeElem(body, target, mask)
                })
            }
        }

        el.innerText = text
        body.appendChild(mask)
        body.appendChild(el)
        setTimeout(function () {
            fadeIn(el)
        })
    }

    {
        var removeElem = function (parent, el, mask) {
            //确保它存在于body中
            if (el && el.parentNode) {
                dom.removeClass(el, 'animate-text-waiting')
                parent.removeChild(el)
                parent.removeChild(mask)
            }
        }

        var fadeOut = function (el) {
            el.style.opacity = 0
        }

        var fadeIn = function (el) {
            el.style.opacity = 1 
        }
    }

     
    return {
        show: function (text, duration) {
            text = text || ""
            duration = duration || 1000

            appendDom(text)
            clearTimeout(timer)
            timer = setTimeout(function () {
                supportTransition ? fadeOut(el) : removeElem(body, el, mask)
            }, duration)
        },
        showLoading: function (text) {
            appendDom(text || '搜索中')
            dom.addClass(el, 'animate-text-waiting')
        },
        hideLoading: function () {
            removeElem(body, el, mask)
        }
    }
});
